module.exports = __webpack_public_path__ + "img/dni-dorso.bcce3848.png";